import { Navigate } from 'react-router-dom';
import useAuth from './UseAuth';

const GuestGuard = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Navigate to="/dashboards/main" />;
  }

  return children;
};

export default GuestGuard;
